export enum OrganizationSettingTab {
    GENERAL = 'general',
    ADVANCED = 'advanced',
    EMAIL = 'email',
    LOGIN_CUSTOMIZATION = 'loginCustomization',
}

export type OrganizationSettingTabType = typeof OrganizationSettingTab[keyof typeof OrganizationSettingTab];
